module.exports = __webpack_public_path__ + "static/media/users.889d9747.svg";